import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getPreferenceTagsInput,
  getPreferenceTagInput,
  PreferenceTagLiteModel,
  PreferenceTagModel,
  getPreferenceGroupsInput,
  PreferenceTagItemModel,
  getPreferenceGroupInput,
} from './model';

export function useGetPreferenceGroups(
  input?: getPreferenceGroupsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<PreferenceTagItemModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<PreferenceTagItemModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPreferenceGroupPreferences', input?.params],
      () =>
        QueryFetchFunction({
          url: 'preference-groups/preferences',
          params: input?.params,
        }),
      options,
    ),
    PreferenceTagItemModel,
  );
}

export function useGetPreferenceGroup(
  input?: getPreferenceGroupInput,
  options?: UseQueryOptions<ApiResult<PreferenceTagItemModel>, ApiError>,
): UseQueryResult<ApiResult<PreferenceTagItemModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPreferenceGroupPreference', input?.id],
      () =>
        QueryFetchFunction({
          url: `preference-groups/preferences/${input?.id}`,
        }),
      options,
    ),
    PreferenceTagItemModel,
  );
}

export function useGetPreferenceTags(
  input?: getPreferenceTagsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<PreferenceTagLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<PreferenceTagLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPreferenceTags', input?.params],
      () =>
        QueryFetchFunction({
          url: 'preference-groups',
          params: input?.params,
        }),
      options,
    ),
    PreferenceTagLiteModel,
  );
}

export function useGetPreferenceTag(
  input?: getPreferenceTagInput,
  options?: UseQueryOptions<ApiResult<PreferenceTagModel>, ApiError>,
): UseQueryResult<ApiResult<PreferenceTagModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getPreferenceTag', input?.id],
      () => QueryFetchFunction({ url: `preference-groups/${input?.id}` }),
      options,
    ),
    PreferenceTagModel,
  );
}

export function getPreferenceTagsKey(input?: getPreferenceTagsInput) {
  return ['getPreferenceTags', input?.params];
}

export function getPreferenceGroupsKey(input?: getPreferenceGroupsInput) {
  return ['getPreferenceGroupPreferences', input?.params];
}

export function getPreferenceTagKey(input?: getPreferenceTagInput) {
  return ['getPreferenceTag', input?.id];
}

export function getPreferenceGroupPreferenceKey(
  input?: getPreferenceGroupInput,
) {
  return ['getPreferenceGroupPreference', input?.id];
}
